// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation_container__wYWv5","bookImage":"navigation_bookImage__KjVjI"};